export enum PdfPreviewType {
  File,
  Url,
}
